// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignIn_ageVerificationContainer__mR8DD .SignIn_buttonStyle__00BVb {
  width: 100px;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/auth/sign-in/SignIn.module.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,aAAA;AAAJ","sourcesContent":[".ageVerificationContainer {\n  .buttonStyle {\n    width: 100px;\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ageVerificationContainer": `SignIn_ageVerificationContainer__mR8DD`,
	"buttonStyle": `SignIn_buttonStyle__00BVb`
};
export default ___CSS_LOADER_EXPORT___;
